import { render, staticRenderFns } from "./CollectionsPaymentPortals.vue?vue&type=template&id=f216b806"
import script from "./CollectionsPaymentPortals.vue?vue&type=script&lang=js"
export * from "./CollectionsPaymentPortals.vue?vue&type=script&lang=js"
import style0 from "./CollectionsPaymentPortals.vue?vue&type=style&index=0&id=f216b806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports